Drupal.behaviors.kinaxisBenefitsScroller = {
  attach(context) {
    const components = context.classList && context.classList.contains('paragraph--type--benefits-scroller')
      ? [context] : context.querySelectorAll('.paragraph--type--benefits-scroller');
    if (!components) { return; }

    components.forEach((element) => {
      // Dynamically change active toc item in the list
      const container = element.querySelector('.field--name-field-p-scroller-content');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          // Check if the element has the class .paragraph--type--scroller-content
          const isScrollerContent = entry.target.classList.contains('paragraph--type--scroller-content');
          // if it is, then check if it is in view and if the top is above the center of the viewport and the bottom is below the center of the viewport.

          if (entry.isIntersecting) {
            // Element is in view
            entry.target.classList.add('active');
          } else if (isScrollerContent && entry.isIntersecting && entry.boundingClientRect.top < window.innerHeight / 2 && entry.boundingClientRect.bottom > window.innerHeight / 2) {
            // Element is in view
            entry.target.classList.add('active');
          }
          else {
            entry.target.classList.remove('active');
            // Element is not in view
          }
        });
      });
      observer.observe(container);


      this.checkActive(element);
      // without a intersection observer, check each item from items to see if the top is above the center of the viewport and the bottom is below the center of the viewport and toggle the active class on it.
      window.addEventListener('scroll', () => {
        this.checkActive(element);
      });

    });
  },
  checkActive(element) {
    var items = element.querySelectorAll('.paragraph--type--scroller-content');
    items =  [...items];
    const elementBottom = element.getBoundingClientRect().bottom;
    if (!items) { return; }

    // Reverse the list to help reduce jumpiness by processing the last
    // item first.
    items.reverse().forEach((item, i) => {
      const rect = item.getBoundingClientRect();

      // Get .field--name-field-media and get its height.
      const media = item.querySelector('.field--name-field-media');
      const mediaHeight = media ? media.offsetHeight / 2 : 0;

      // get the bottom position of the media.
      const mediaBottom = media ? media.getBoundingClientRect().bottom : 0;
      if (mediaBottom >= elementBottom) {
        item.classList.remove('active');
        element.classList.add('end');
      } else {
        element.classList.remove('end');
      }

      if (!element.classList.contains('end')) {
        // if the top of the element is above the center of the viewport and the bottom is below the center of the viewport, then add the active class to the element.
        if (rect.top < window.innerHeight / 2 - mediaHeight && rect.bottom > window.innerHeight / 2 - mediaHeight) {
          // remove all other items with the active class
          const activeItems = element.querySelectorAll('.paragraph--type--scroller-content.active');
          if (activeItems.length > 1) {
            items.forEach((item) => {
              item.classList.remove('active');
            });
          }
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      }

    });

    // if there are active items, then set a class element active-items
    const activeItems = element.querySelectorAll('.paragraph--type--scroller-content.active');
    // check if element is in the viewport
    const rect = element.getBoundingClientRect();
    const isElementInViewport = rect.top < window.innerHeight && rect.bottom > 0;
    if (activeItems.length > 0 && isElementInViewport) {
      element.classList.add('active-items');
      element.classList.remove('no-active-items');
      element.classList.remove('in-viewport');
    } else if (!isElementInViewport) {
      element.classList.add('no-active-items');
      element.classList.remove('active-items');
      element.classList.remove('in-viewport');
    } else if (isElementInViewport) {
      element.classList.add('in-viewport');
      // element.classList.add('no-active-items');
    } else {
      element.classList.remove('in-viewport');
      element.classList.remove('active-items');
      element.classList.add('no-active-items');
    }
  },
};
